import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Dialog } from './Dialog';
import styles from './Dialog.module.css';

/** Eigenschaften des Bestätigungsdialogs. */
interface ConfirmDialogProps {
  /** Überschrift. */
  title: string;
  /** Erläuternder Text. */
  message: string;
  /** Beschriftung der bestätigenden Schaltfläche. */
  confirmLabel: string;
  /** Ob der Dialog geöffnet ist. */
  isOpen: boolean;
  /** Während `true` ist die Bestätigung gesperrt (laufende Aktion). */
  busy?: boolean;
  /** Wird bei Bestätigung aufgerufen. */
  onConfirm: () => void;
  /** Wird bei Abbruch aufgerufen. */
  onCancel: () => void;
}

/**
 * Bestätigungsdialog für riskante Aktionen (z. B. Löschen).
 * @param props Texte, Zustand und Callbacks.
 */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  isOpen,
  busy,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog title={title} isOpen={isOpen} onClose={onCancel}>
      <p>{message}</p>
      <div className={styles.actions}>
        <Button variant="secondary" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm} disabled={busy}>
          {confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
